export default {
    path: '',
    component: () => import(`@/component/admin-layout/index.vue`),
    children: [
        {
            path: '/admin/yinzhilv/demo-HotelForeignCitySelector',
            name: 'admin-yinzhilv-demo-HotelForeignCitySelector',
            component: () => import(`./index.vue`),
            meta: {
                entity_for_history_tag: {
                    name: `demo-HotelForeignCitySelector`,
                },
                entity_list_for_breadcrumb: [
                    {name: `demo`},
                    {name: `demo-HotelForeignCitySelector`},
                ],
            },
        },
    ],
};
